import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { InactiveService } from '../services/inactive.service'

@Component({
  selector: 'hs-reload-page',
  templateUrl: './reload-page.component.html',
  styleUrls: ['./reload-page.component.scss'],
})
export class ReloadPageComponent {
  constructor(
    private readonly inactiveService: InactiveService,
    private readonly route: ActivatedRoute,
  ) {
    this.inactiveService.isVisible$.subscribe(isVisible => {
      if (!isVisible) {
        return
      }

      this.route.queryParams.subscribe(params => {
        if (params.redirect) {
          this.redirectToPath(params.redirect)
        }
      })
    })

    this.inactiveService.init()
  }

  redirectToPath(path: string) {
    window.location.href = path
  }
}
